import React from 'react';
import styled from 'styled-components';
import {Subhead, Caption2, Caption1} from '../../components/Typography';
import {getWeekdaysFromToday} from '../../utils/formatTime';

const HoursTypeTitle = styled(Subhead)`
  margin-bottom: 8px;
  margin-top: 15px;
`;

const HoursRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
`;

const HoursColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
`;

const DayOfWeek = styled(Caption1)`
  text-transform: capitalize;
  font-weight: ${props => (props.index === 0 ? '600' : '0')};
`;

const TimeOfDay = styled(Caption1)`
  font-weight: ${props => (props.index === 0 ? '600' : '0')};
`;

export default function WeeklyTimeSlots({id, title, hours}) {
  const weekdaysFromToday = getWeekdaysFromToday();
  return (
    <>
      <HoursTypeTitle id={id}>{title}</HoursTypeTitle>
      {weekdaysFromToday.map((dayOfWeek, index) => (
        <HoursRow key={dayOfWeek}>
          <DayOfWeek index={index}>{dayOfWeek}</DayOfWeek>
          {hours[dayOfWeek].length > 0 ? (
            <HoursColumn>
              {hours[dayOfWeek].map(dayInfo => (
                <TimeOfDay index={index}>{dayInfo}</TimeOfDay>
              ))}
            </HoursColumn>
          ) : (
            <Caption2>Closed</Caption2>
          )}
        </HoursRow>
      ))}
    </>
  );
}
